import buy from './buy';
import rent from './lease';
import sold from './sold';
import leased from './leased';
import invest from './invest';

export default { buy, rent, sold, leased, invest };
